import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {computed, ref, watch} from 'vue';
import tokenRepository from '@/app/shared/infrastructure/persistence/token-repository';
import {API_URL_BASE} from '@/env';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputAvatar',
  props: ['src', 'modelValue', 'imagePath'],
  emits: ['update:modelValue'],
  setup(__props, { emit: emits }) {

const props = __props;

const token = tokenRepository().get();


const picture = ref([]);
const fileSrc = ref('');
const fileInput = ref(null);
const imgSrc = computed(() => {
    return fileSrc.value != '' ? fileSrc.value : `${API_URL_BASE}/assets/images--${props.imagePath}--${props.src}/${token}`;
});

const handleFileEditClick = () => {
    fileInput.value.click();
};

watch(picture, (newPicture) => {
    const fileReader = new FileReader();
    fileReader.onload = () => {
        fileSrc.value = fileReader.result;
    };
    fileReader.readAsDataURL(newPicture[0]);
    emits('update:modelValue', newPicture[0]);
});

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_file_input = _resolveComponent("v-file-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_avatar, {
      color: "grey",
      size: "150",
      rounded: "0"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_img, {
          cover: "",
          src: _unref(imgSrc)
        }, null, 8, ["src"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_btn, {
      class: "ma-3",
      onClick: handleFileEditClick,
      icon: "mdi:mdi-pencil",
      color: "primary",
      size: "x-small"
    }),
    _createVNode(_component_v_file_input, {
      modelValue: picture.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((picture).value = $event)),
      ref_key: "fileInput",
      ref: fileInput,
      class: "d-none"
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})